import styled, { css } from 'styled-components';

import { NeutralColors } from '@/theme';

export const Sidebar = styled.aside<{
  $isMenuCollapsed: boolean;
  $backgroundColor?: string;
}>`
  max-width: 250px;
  min-width: 250px;
  width: 250px;
  height: 100%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  position: relative;
  transition: all 0.2s;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ $isMenuCollapsed }) =>
    $isMenuCollapsed &&
    css`
      max-width: 64px;
      min-width: 64px;
      width: 64px;
    `}
`;

export const SidebarMenu = styled.ul`
  list-style: none;
  padding: 0 !important;
  margin: 0;
  margin-top: 16px;
  display: grid;
  grid-row-gap: 4px;
  align-content: start;
  /* The list is the only growable region of the sidebar: it must be able to
     shrink below its content height (min-height: 0) so long expanded menus
     scroll here instead of overflowing the sidebar's painted background. */
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${NeutralColors[70]};
    border-radius: 4px;
  }
`;

export const SubMenuList = styled.ul`
  list-style: none;
  padding: 0 !important;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SidebarMenuFooter = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 8px;
  background: ${NeutralColors[100]};
  bottom: 0;
  color: ${NeutralColors[0]};
  text-align: center;
  transition:
    all 0.2s,
    background 0s;
  z-index: 1;

  button {
    cursor: pointer;
    background: transparent;
    border: none;
    cursor: pointer;
    height: 48px;
    width: 48px;
  }
`;
